<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">corporate culture</div>
      <div class="contentTitle">管理团队</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="gltd_item">
        <div class="item " style="width: 100%">
          <img style="width: 100%" :src="src.chairman" alt />
        </div>
        <div class="item">
          <div class="itemName">杨清</div>
          <div class="itemPosition">首席CEO</div>
          <div class="itemDet">云久鸿创始人</div>
          <div class="itemDet">
            致力于人力资源行业20年，现受聘富士康首席管理咨询顾问，以前瞻性研究引领人力资源行业高质量发展，被称为人力资源行业引领者。
          </div>
        </div>
      </div>
<!--      <div class="border_item">-->
<!--        <div class="item detBox">-->
<!--          <div class="itemName">瞿春鸿</div>-->
<!--          <div class="itemPosition">首席COO</div>-->
<!--          <div class="itemDet">云久鸿创始人</div>-->
<!--          <div class="itemDet">-->
<!--            高级人力资源管理师，深耕人力资源行业20年，丰富的团队管理实战经验，NLP性格执行师。-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item imgBox">-->
<!--          <div class="imgBg">-->
<!--            <img :src="src.bgc"  alt />-->
<!--          </div>-->
<!--          <img :src="src.general" alt />-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div class="mobile_contentBox">
      <div class="contentStitle">corporate culture</div>
      <div class="contentTitle">管理团队</div>
      <div class="gltd_item">
        <div class="item">
          <img :src="src.chairman" alt />
        </div>
        <div class="item item_right">
          <div class="itemTitle">
            <div class="itemName">杨清</div>
            <div class="itemPosition">首席CEO</div>
          </div>
          <div class="itemJob">云久鸿创始人</div>
          <div class="itemDet">
            致力于人力资源行业20年，现受聘富士康首席管理咨询顾问，以前瞻性研究引领人力资源行业高质量发展，被称为人力资源行业引领者。
          </div>
        </div>
      </div>
<!--      <div class="gltd_item border_item">-->
<!--        <div class="item item_left">-->
<!--          <div class="itemTitle">-->
<!--            <div class="itemName">瞿春鸿</div>-->
<!--            <div class="itemPosition">首席COO</div>-->
<!--          </div>-->
<!--          <div class="itemJob">云久鸿创始人</div>-->
<!--          <div class="itemDet">-->
<!--            高级人力资源管理师，深耕人力资源行业20年，丰富的团队管理实战经验，NLP性格执行师。-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="item imgBox">-->
<!--          <div class="imgBg">-->
<!--            <img :src="src.ceo" alt />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 999px) {
  .gltd_item {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
    .item {
      width: 150px;
      img {
        width: 100%;
      }
      .itemTitle {
        display: flex;
        align-items: center;
        .itemName {
          margin-right: 20px;
          font-size: 16px;
          font-weight: 700;
        }
        .itemPosition {
          padding: 5px 10px;
          border-radius: 24px;
          background-color: #da261d;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .itemJob {
        font-weight: 700;
        color: #666666;
        text-align: left;
        line-height: 18px;
      }
      .itemDet {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
      }
    }
    .imgBox {
      width: 130px;
      img {
        width: 100%;
      }
    }
    .item_right {
      margin-left: -20px;
    }
    .item_left {
      width: 170px;
    }
  }
  .border_item {
    justify-content: space-between;
    margin: 10px;
    border: 2px solid #da261d;
    padding: 5px 10px 0 10px;
  }
}
@media screen and (min-width: 1000px) {
  .mobile_contentBox {
    display: none;
  }
  .gltd_item {
    display: flex;
    margin-top: 50px;
    .item {
      flex: 1;
      padding: 50px;
      text-align: left;
    }
  }

  .border_item {
    display: flex;
    border: 6px solid #da261d;
    padding: 50px 50px 0 0;
    margin-bottom: 100px;

    .detBox {
      width: 60%;
      padding: 0 100px;
      text-align: left;
    }
    .imgBox {
      width: 40%;
      position: relative;
      .imgBg {
        position: absolute;
        top: 100px;
        z-index: -1;
      }
    }
  }
  .itemName {
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #da261d;
    line-height: 60px;
  }
  .itemPosition {
    width: 198px;
    height: 47px;
    border-radius: 24px;
    background-color: #da261d;
    font-size: 26px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 51px;
    text-align: center;
    margin: 20px 0;
  }
  .itemDet {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 51px;
  }
}
</style>
